<div tabindex="2" class="text-template-editor form-control pe-30" placeholder="Type your test message here"
  [ngClass]="{ 'is-disabled text-neutral-n6': isDisabled }" [attr.contenteditable]="isDisabled ? false : true"></div>
